import { z } from "zod";

import type { FlowMeta } from "./types";

/**
 * Zod schema for {@link FlowMeta} — the flow's document-head metadata. The flow
 * is server-only, so its base title is forwarded to the client on the loader
 * response ({@link import("../response/types").ViewResponse}) and validated here.
 */
export const FlowMetaSchema = z.object({
  title: z.string(),
}) satisfies z.ZodType<FlowMeta>;
